const initialState = {
  isFetching: false,
  isFetched: false,
  isError: false,
  isSuccess: false,
  isGenericAddress: false,
  data: {}
}

export const ACTION_TYPES = {
  ADDRESS_INFO_REQUEST: 'ADDRESS_INFO_REQUEST',
  ADDRESS_INFO_SUCCESS: 'ADDRESS_INFO_SUCCESS',
  ADDRESS_INFO_ERROR: 'ADDRESS_INFO_ERROR',
  GET_POSTALCODE_REQUEST: 'GET_POSTALCODE_REQUEST',
  GET_POSTALCODE_SUCCESS: 'GET_POSTALCODE_SUCCESS',
  GET_POSTALCODE_ERROR: 'GET_POSTALCODE_ERROR',
  KEEP_STATE: 'KEEP_STATE'
}

export const getAddressInfo = () => ({
  type: ACTION_TYPES.ADDRESS_INFO_REQUEST
})

export const getPostalCodeInfo = postalCode => ({
  type: ACTION_TYPES.GET_POSTALCODE_REQUEST,
  payload: postalCode
})

export const keepState = payload => ({
  type: ACTION_TYPES.KEEP_STATE,
  payload
})

const isBlank = value => !value

const hasGenericPostalCode = (data = {}) =>
  ['streetName', 'neighborhood'].find(key => isBlank(data[key])) !== undefined

const getVerifiedPostalAddress = (state, payload) => ({
  ...state,
  data: {
    ...payload.data,
    countryCode: { key: 'BRA', value: 'Brasil' },
    proofOfResidence: state.data.proofOfResidence
  },
  isFetching: false,
  isFetched: true,
  isError: false,
  isSuccess: true,
  isGenericAddress: hasGenericPostalCode(payload.data)
})

const addressInfo = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.ADDRESS_INFO_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.ADDRESS_INFO_SUCCESS:
      return {
        ...state,
        data: payload.data,
        isFetching: false,
        isFetched: true,
        isError: false,
        isSuccess: true
      }
    case ACTION_TYPES.ADDRESS_INFO_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        isError: true,
        isSuccess: false
      }
    case ACTION_TYPES.GET_POSTALCODE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.GET_POSTALCODE_SUCCESS:
      return getVerifiedPostalAddress(state, payload)
    case ACTION_TYPES.GET_POSTALCODE_ERROR:
      return {
        ...state,
        isFetching: false,
        isFetched: true,
        isError: true,
        isSuccess: false
      }
    case ACTION_TYPES.KEEP_STATE:
      return {
        ...state,
        data: Object.assign({}, payload),
        isFetching: false,
        isFetched: true,
        isError: false,
        isSuccess: true
      }
    default:
      return state
  }
}

export default addressInfo
